import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
  },
  iconButtonScrollRight: {
    bgGradient: 'linear(to-b, beta.300, beta.400)',
    boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.3)',
    color: 'alpha.700',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
    border: 'none',
    h: 9,
    w: 'auto',
    minW: '4',
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
  },
  iconButtonScrollLeft: {
    bgGradient: 'linear(to-b, beta.300, beta.400)',
    boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.3)',
    color: 'alpha.700',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
    border: 'none',
    h: 9,
    w: 'auto',
    minW: '4',
  },
  flexWrapper: {
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  },
  buttonGroupSports: {
    display: 'inline-flex',
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    borderRadius: ['none', null, 'base'],
    flex: '1',
    overflowX: 'auto',
    p: '1',
    spacing: '1',
    whiteSpace: 'nowrap',
    sx: { '::-webkit-scrollbar': { display: 'none' } },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    p: '0',
    pl: 1,
    gap: 0.5,
    isAttached: true,
  },
};
